import { PlayerPBLPage } from '@hendrx/core/pbl/pages/PlayerPBLPage';
import { createFileRoute } from '@tanstack/react-router';

import { useResponsiveRootFontSize } from 'shared/utils/useResponsiveRootFontSize';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import { requireAuthenticated, requirePreviewModeAllowed, STUDIO_ROLES } from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/player/pbl/$pblDraftId')({
  beforeLoad: createRouteGuard(requireAuthenticated(), requirePreviewModeAllowed({ allowedRoles: STUDIO_ROLES })),
  component: PlayerPBLPageComponent
});

function PlayerPBLPageComponent() {
  useResponsiveRootFontSize({ minFontSize: 8 });

  const { pblDraftId } = Route.useParams();

  return <PlayerPBLPage pblDraftId={pblDraftId} />;
}
